import { render } from "./BatchBankAccountSelectionContainer.vue?vue&type=template&id=72bbf72e"
import script from "./BatchBankAccountSelectionContainer.vue?vue&type=script&lang=js"
export * from "./BatchBankAccountSelectionContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__